export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/woocomerceUsers/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/woocomerceUsers',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/woocomerceUsers',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/woocomerceUsers/${id}`,
      data: payload,
    });
  },
});
